export default __webpack_public_path__ + "static/media/backgroundBuild.e94034cb.png";